import "./ManageUser.scss";

import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import Input from "components/Input/Input";
import Table from "components/Table/Table";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
export interface Query {
    id: number;
    query: string;
    limit: number;
    is_processing: boolean;
    created_at: string;
}


export default function GuestPostFinder(props: { guest_post_finder_queries: Array<Query> }) {
    // ---------------------- NON STATE CONSTANTS ----------------------
    const pageSizes = [10, 25, 50, 100];
    
    // ---------------------- STATES ----------------------
    const [searchBoxFilter, setSearchBoxFilter] = useState("");
    const [showGuestPost, setGuestPost] = useState(false);
    const navigate = useNavigate();

    // ---------------------- TABLE COLUMN DEFS ----------------------
    const columnHelper = createColumnHelper<Query>();
    const columnDefs: ColumnDef<any, any>[] = [
        columnHelper.accessor((row) => row.query, {
            id: "Topic",
            header: "Topic",
            cell: (info) =>
                <NavLink to={`/view-guest-post-finder/${info.row.original.id}`}>
                    {info.getValue()}
                </NavLink>,
            enableGlobalFilter: true,
        }),
        columnHelper.accessor((row) => row.limit, {
            id: "limit",
            header: "Limit",
            cell: (info) => info.getValue(),
            enableGlobalFilter: false,
        }),
        columnHelper.accessor((row) => row.created_at, {
            id: "created_on",
            header: "Created On",
            cell: (info) => {
                const date = new Date(info.getValue());
                return date.toLocaleString();
            },
            enableGlobalFilter: false,
        }),
    ];

    // ==============================================================  
    // ---------------------- MAIN RENDER CODE ----------------------
    // ==============================================================  
    return (
        <div className={"card w-100 mt-4"}>
            <header
                className="card-header is-clickable"
                onClick={() => setGuestPost(!showGuestPost)}
                >
                <p className="card-header-title">
                    Guest Post Projects
                </p>
                <span className="card-header-icon">
                  <FontAwesomeIcon icon={showGuestPost ? faChevronDown : faChevronRight} />
                </span>
            </header>
            {showGuestPost && (
            <div className={"card-content"}>
                <div className={"content"}>
                    <div className={"all-users-container"}>
                        <div className={"table-controls"}>
                            {/* -------------------------- SEARCH BOX -------------------------- */}
                            <Input
                                type={"text"}
                                className={"table-searchbox"}
                                placeholder={"Search for Queries..."}
                                value={searchBoxFilter ?? ""}
                                onChange={(e) => {
                                    setSearchBoxFilter(String(e.target.value));
                                }}
                            />
                        </div>
                        <Table
                            tableContentName={"Guest Post Queries"}
                            tableData={props.guest_post_finder_queries}
                            columnDefs={columnDefs}
                            pageSizes={pageSizes}
                            initialPageSize={pageSizes[0]}
                            noDataText={"No Queries Found"}
                            searchBoxValue={searchBoxFilter}
                        />
                    </div>
                </div>
            </div>
            )}
        </div>
    );
}
